import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    allowClear: false,
    placeholder: 'Select',
  };
  
  connect() {
    this.initSelect2()
    this.initEventListeners()
  }

  initSelect2() {
    $(this.element).select2({
      width: "100%",
      allowClear: this.allowClearValue,
      placeholder: this.placeholderValue,
    });
  }

  initEventListeners() {
    const fireChangeEvent = () =>
      this.element.dispatchEvent(new Event("change"));

    const unSelectEvent = () => this.element.dispatchEvent(new Event("change"));

    $(this.element).on("select2:select", fireChangeEvent);
    $(this.element).on("select2:unselecting", unSelectEvent);

    $(document).on("turbo:before-cache", () => {
      if($(this.element).data('select2')){
        $(this.element).select2("destroy");
      }
    });
  }
}
